import { Injectable } from '@angular/core';
import { SellerRole } from './sellers.service';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';

export const STORE_MEMBERSHIPS_API_NAME: string = 'store_memberhips';
export const STORE_MEMBERSHIPS_API_ENDPOINT: string = environment.API_BASE_PATH + '/store-membership';

@Injectable({
  providedIn: 'root',
})
export class StoreMembershipsService {
  listStoreMembershipsBySellerId(seller_id: string): Observable<any> {
    const api_name: string = STORE_MEMBERSHIPS_API_NAME;
    const path: string = `/seller/${seller_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  listStoreMembershipsByStoreId(store_id: string): Observable<any> {
    const api_name: string = STORE_MEMBERSHIPS_API_NAME;
    const path: string = `/store/${store_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export class StoreMembership {
  seller_id?: string;
  store_id?: string;
  store_name?: string;
  store_logo_icon?: string;
  seller_firstname?: string;
  seller_lastname?: string;
  seller_email?: string;
  role?: SellerRole;
  created_at?: number;
  updated_at?: number;
  seller_role?: string;
}
